// Only a single horizontal sequence participates in shared option sizing.
// Time steps, matrices, and sequences mixed with prose keep their own layout.
export function patternChoiceSequenceLength(value) {
  if (value?.kind === 'sequence_tokens') return (value.tokens || []).length;
  if (value?.kind === 'library_sequence') {
    const parts = value.parts || [];
    if (parts.every((part) => part?.kind === 'library_symbol'
      || (part?.kind === 'text' && !String(part.text || '').trim()))) {
      return parts.filter((part) => part?.kind === 'library_symbol').length;
    }
  }
  return 0;
}
